export default {
    thirdPartyDependenciesTitle: 'Våre tredjepartslisenser',
    thirdPartyDependenciesDescription: 'Her er en samling av alle relevante lisenser vi benytter oss av i mobilbanken.',
    thirdPartyDependenciesLink: 'Tredjepartslisenser',
};
